import { type FC } from "react";

import { Flexbox } from "../../../shared/components";
import { ValueSkeleton } from "../ValueSkeleton";

import { LegendItemMarker, LegendItemValue, LengendItemLabel } from "./LegendItem.styles";

interface LegendItemProps {
    name: string;
    color: string;
    value: string;
    loading: boolean;
}

export const LegendItem: FC<LegendItemProps> = ({ name, color, value, loading }) => {
    return (
        <div>
            <Flexbox alignItems="center">
                <LegendItemMarker background={color} />
                <LengendItemLabel>{name}</LengendItemLabel>
            </Flexbox>
            <LegendItemValue>{loading ? <ValueSkeleton /> : value}</LegendItemValue>
        </div>
    );
};
